/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSelector } from "@reduxjs/toolkit";
import { encode as base64Encode } from "base-64";
import { AppState } from "../../../../store";
import { deviceSiteGroupSelector } from "../../../../store/filters/Nodes/selectors";

interface IFilterObj {
  type: string;
  operator: string;
  fieldName: string;
  value: string | number;
  predicates: {}[];
}


export const eventFilterSelector = (state: AppState) => state.eventfilter;
export const eventFilterSeveritySelector = (state: AppState) => state.eventfilter.selectedEventSeverity;
export const eventFilterManagedObjectSelector = (state: AppState) => state.eventfilter.selectedManagedObject;
export const eventFilterEventTypeSelector = (state: AppState) => state.eventfilter.selectedEventType;
export const eventFilterEventTimeSelector = (state: AppState) => state.eventfilter.selectedEventTime;
export const eventFilterHostNameSelector = (state: AppState) => state.eventfilter.selectedHostName;
export const dataGridSortSelector = (state: AppState) => state.helpers.sortModel;
export const eventFilterMaintenanceModeSelector = (state: AppState) => state.eventfilter.selectedMaintenanceMode;
export const eventFilterParentKeySelector = (state: AppState) => state.eventfilter.parentKey;
const selectedGeoRegionSelector = (state: AppState) => state.admin.selectedGeoRegion.name || "";
export const deviceKpiSyncSelector = (state: AppState) => state.filter.pmCollected;
export const deviceStatusSelector = (state: AppState) => state.filter.selectedDeviceStatus;
export const isDevicePageSelector = (state: AppState) => state.eventfilter.isDeviceDetailPage;


export const urlRedundancySelector = createSelector(
  deviceSiteGroupSelector,
  eventFilterSeveritySelector,
  eventFilterManagedObjectSelector,
  eventFilterEventTypeSelector,
  eventFilterEventTimeSelector,
  eventFilterHostNameSelector,
  eventFilterMaintenanceModeSelector,
  eventFilterParentKeySelector,
  selectedGeoRegionSelector,
  deviceKpiSyncSelector,
  deviceStatusSelector,
  isDevicePageSelector,
  (siteGroup: string, severity, managedObject, eventType, eventTime, hostName, maintenanceMode, parentKey, geoRegionName, pmCollected, status, isDeviceDetailPage) => {
    const params = new URLSearchParams();
    const isDeviceDetail = isDeviceDetailPage
    const isEnableFilter = severity || managedObject || eventType || eventTime || hostName || maintenanceMode || parentKey || geoRegionName || isDeviceDetail;
    if (isEnableFilter) {
      const paramsString: IFilterObj = {
        "type": "AND",
        "operator": "",
        "fieldName": "",
        "value": "",
        "predicates": [
          {
            "type": "",
            "operator": "EQUAL",
            "fieldName": "parentKey",
            "value": "Server",
            "predicates": [
              {}
            ]
          },
          {
            "type": "",
            "operator": "EQUAL",
            "fieldName": "managedObject",
            "value": "Redundancy Manager",
            "predicates": [
              {}
            ]
          }
        ]
      }
      if (severity) {
        paramsString.predicates.push({ type: "", operator: "EQ", fieldName: "severity", value: severity, predicates: [{}] });
      }
      const base64EncodedStr = base64Encode(JSON.stringify(paramsString));
      if (paramsString?.predicates.length > 0) {
        base64EncodedStr && params.append("filters", base64EncodedStr);
      }
      //console.log("Report Filter", decode(base64EncodedStr));
    }
    return params;
  }
);
